var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('legend',[_vm._v("Email")]),_vm._v(" "),_c('form-group',{attrs:{"type":"email","metadata":_vm.metadata[_vm.mEmail],"$v":_vm.$v[_vm.$vEmail],"addon-class":"fa-envelope"},model:{value:(_vm.localEmail),callback:function ($$v) {_vm.localEmail=$$v},expression:"localEmail"}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c61d9b0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Account/Email.vue
// module id = 189
// module chunks = 2 3 4 6